<template>
  <div>
    <!--导航栏     @click-left="onClickLeft"  left-arrow  left-text="返回" start-->
    <van-nav-bar title="选择门店" right-text="添加门店" @click-right="onClickRight" fixed />
    <!-- <div class="navBar">
      <div class="title">选择门店</div>
      <div class="add" @click="onClickRight">添加门店</div>
    </div>-->
    <!--导航栏 end-->
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        @click="onSubmit(admin.store_num)"
        size="large"
        v-for="(admin,index) in list"
        :key="index"
        :title="admin.store_name"
        is-link
        :value="admin.store_num"
      />
    </van-list>
  </div>
</template>

<script>
import { Notify, Toast } from "vant";

export default {
  name: "StoreImpower", //选择门店登录
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 2,
      ta: "111",
      iosAndr: false,
    };
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = "#f5f5f5";
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "";
    next();
  },
  mounted() {
    // this.onSubmit()
    this.GetQueryString("openid");

    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      console.log("ios");
      this.iosAndr = false;
    } else {
      console.log("安卓");
      this.iosAndr = true;
    }
  },
  methods: {
    // 左侧返回
    // onClickLeft() {
    //   this.$router.push("/");
    //   // window.history.go(-1)
    // },
    onClickRight() {
      this.$router.push("/StoreLogin");
      // Toast('添加商户');
    },

    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        window.localStorage.setItem("openid", unescape(r[2]));
        return unescape(r[2]);
      }

      return null;
    },

    //点击商户登录
    onSubmit(e) {
      window.sessionStorage.setItem("tag", this.ta);
      var toast = Toast.loading({
        duration: 0,
        message: "登录中",
        forbidClick: true,
        loadingType: "spinner",
      });
      // console.log('submit', values);
      this.$http
        .get("/wechat/login/login", {
          params: {
            openid: window.localStorage.getItem("openid"),
            account: e,
            type: "store",
          },
        })
        .then((response) => {
          toast.clear();
          console.log(response.data);
          if (response.data.code == 200) {
            window.sessionStorage.setItem(
              "commercialId",
              response.data.data.merchant_id
            ),
              window.sessionStorage.setItem("tokens", response.data.data.token);
            window.sessionStorage.setItem(
              "store_id",
              response.data.data.store_id
            );
            // window.sessionStorage.setItem("username",this.username)

            this.$router.push("/StoreHomepage");

            // VueCookie.set('salesmanInfo', response.data.data, 360000);
            // window.location.href = that.redirect;
          } else {
            Notify({ type: "danger", message: response.data.msg });
          }
        });
    },

    onLoad() {
      // window.location.href = `http://192.168.3.9:80/wechat/login/authLogin`

      var that = this;
      // var salesmanInfo = VueCookie.get("salesmanInfo");
      this.$http
        .get("/wechat/login/lst", {
          params: {
            // id: salesmanInfo.id,
            openid: window.localStorage.getItem("openid"),
            page: that.page,
            limit: that.limit,
            type: "store",
          },
        })
        .then((response) => {
          // 加载状态结束
          that.loading = false;
          // console.log(response.data.data)
          // that.list = that.list.concat(response.data)
          // console.log(that.list)
          // 页码

          // this.finished = true;
          if (response.data.data.length) {
            that.list.push(...response.data.data);
            that.finished = false;
            that.page++;
          } else that.finished = true;
        });
    },
  },
};
</script>

<style >
.list {
  margin-top: 1rem;
}
.navBar {
  display: flex;
  background: #fff;
  line-height: 80px;
}
.title {
  width: 60%;
  display: flex;
  justify-content: flex-end;
  font-size: 17px;
}
.add {
  width: 40%;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  color: #1989fa;
  font-size: 16px;
}
</style>
